export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/welcome_lady-aeb2d307d3f15cb055255cf0ccc34ef9.svg";